import { Container } from '@components/layout/grid'
import PhoneVerification from '@components/onboarding/shared-flows/phone-verification'
import analyticsService from '@lib/analytics/AnalyticsService'
import { AnalyticsEvent } from '@lib/analytics/events'
import { GoogleAdsConversionEvent } from '@lib/analytics/googleAds/conversions'
import googleAdsService from '@lib/analytics/googleAds/GoogleAdsService'
import { generateEventId } from '@lib/analytics/utils'
import { hasCookieConsent } from '@lib/hooks/useCookieConsent'
import { useSession } from '@lib/store/useStores'
import type { PageWithContext } from '@lib/utils/context'
import { getOnboardingLayout } from '@page-templates/onboarding-page'
import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'

const EARLYPAY_FLOW_STARTED_KEY = 'step_conversion_earlypay_flow_started_fired'

export const PhoneVerificationPage: PageWithContext = observer(() => {
    const { recoveryStore } = useSession()
    // Use ref to track in-memory state for deduplication when consent not yet granted
    const hasTrackedRef = useRef(false)

    // Track earlypay flow started event (once per session)
    useEffect(() => {
        // Check both in-memory flag AND storage (storage may exist from previous session with consent)
        if (hasTrackedRef.current) return
        if (sessionStorage.getItem(EARLYPAY_FLOW_STARTED_KEY)) return

        hasTrackedRef.current = true

        // Track with shared eventId for cross-provider reconciliation
        // Events handle consent internally via pending queue
        const eventId = generateEventId()
        analyticsService.trackEvent(AnalyticsEvent.EARLYPAY_FLOW_STARTED, {
            event_id: eventId,
            isRecoveryFlow: !!recoveryStore,
        })
        googleAdsService.trackConversion(
            GoogleAdsConversionEvent.EARLYPAY_FLOW_STARTED,
            { eventId },
        )

        // Only persist to sessionStorage if consent granted (GDPR compliance)
        if (hasCookieConsent()) {
            sessionStorage.setItem(EARLYPAY_FLOW_STARTED_KEY, 'true')
        }
    }, [recoveryStore])

    return (
        <Container>
            <PhoneVerification />
        </Container>
    )
})

PhoneVerificationPage.getLayout = getOnboardingLayout()

export default PhoneVerificationPage
